import { HELLOSIGN_CLIENT_ID } from 'sellDirect/helpers/closingDash/globals';
import HelloSign from 'hellosign-embedded';

const clientId = HELLOSIGN_CLIENT_ID;
export const hellosignInstance = new HelloSign({ clientId });
